// src/api/apiClient.ts
import axios from 'axios';

// Use environment variable or fallback to localhost
// Ensure trailing slash for consistency
const API_URL = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL.replace(/\/+$/, '')}/`
  : 'http://localhost:8000/api/';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor to add token to headers
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Token ${token}`; // Matches your backend's TokenAuthentication
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default apiClient;
